import { useTheme } from '../context/ThemeContext';
import '../App.css';
import BugBeetle from '../assets/icons/light/BugBeetle.svg';
import User from '../assets/icons/light/User.svg';
import BroadCast from '../assets/icons/light/Broadcast.svg';
import User1 from '../assets/images/user1.png';
import User2 from '../assets/images/user2.png';
import User3 from '../assets/images/user3.png';
import User4 from '../assets/images/user4.png';
import User5 from '../assets/images/user5.png';
import User6 from '../assets/images/user6.png';
import User7 from '../assets/images/user7.png';
import User8 from '../assets/images/user8.png';
import User9 from '../assets/images/user9.png';
import User10 from '../assets/images/user10.png';
import User11 from '../assets/images/user11.png';

export default function RightsidePannel({ isOpened }) {
  const { theme } = useTheme();

  const notifications = [
    { icon: BugBeetle, message: 'You have a bug that needs', time: 'Just now' },
    { icon: User, message: 'New user registered', time: '59 minutes ago' },
    { icon: BugBeetle, message: 'You have a bug that needs', time: '12 hours ago' },
    { icon: BroadCast, message: 'Andi Lane subscribed to your channel', time: '12 hours ago' },
  ];

  const activities = [
    { imageSrc: User1, message: 'You have a bug that needs', time: 'Just now' },
    { imageSrc: User2, message: 'Released a new version', time: '59 minutes ago' },
    { imageSrc: User3, message: 'Submitted a bug', time: '12 hours ago' },
    { imageSrc: User4, message: 'Modified A data in Page X', time: 'Today, 11:59 AM' },
    { imageSrc: User5, message: 'Deleted a page in Project X', time: 'Feb 2, 2023' },
  ]

  const contacts = [
    { imageSrc: User6, name: 'Natali Craig' },
    { imageSrc: User7, name: 'Drew Cano' },
    { imageSrc: User8, name: 'Orlando Diggs' },
    { imageSrc: User9, name: 'Andi Lane' },
    { imageSrc: User10, name: 'kate Morris' },
    { imageSrc: User11, name: 'Koray Okumus' },
  ]

  const NotificationItem = ({ icon, message, time }) => (
    <div className="flex items-start gap-2">
      <div className="p-2 bg-[#E3F5FF] rounded-xl shrink-0">
        <img src={icon} alt="Notification icon" className="w-[16px] h-[16px]" />
      </div>
      <div>
        <p className="text-sm truncate w-[192px]">{message}</p>
        <p className="text-xs text-[#6C757D]">{time}</p>
      </div>
    </div>
  );

  const ActivitiesItem = ({ imageSrc, message, time }) => (
    <div className="flex items-start gap-2">
      <div className="p-1 rounded-xl shrink-0">
        <img src={imageSrc} alt="user" className="w-[24px] h-[24px] rounded-full" />
      </div>
      <div>
        <p className="text-sm truncate w-[192px]">{message}</p>
        <p className="text-xs text-[#6C757D]">{time}</p>
      </div>
    </div>
  );

  const ContactsItem = ({ imageSrc, name }) => (
    <div className="flex items-center gap-2">
      <div className="p-1 rounded-xl shrink-0">
        <img src={imageSrc} alt="user" className="w-[24px] h-[24px] rounded-full" />
      </div>
      <div>
        <p className="text-sm truncate w-[192px]">{name}</p>
      </div>
    </div>
  );

  return (
    <div
      className={`fixed top-0 right-0 h-full w-[280px] overflow-y-auto border-l-2 transition-transform duration-900 z-40
      ${isOpened ? 'translate-x-0' : 'translate-x-full'}
      ${theme === '#1c1c1c'
        ? 'bg-[#1c1c1c] text-white border-[#333333]'
        : 'bg-white text-black border-[#e8e8e8]'
      }`}
    >
      <div className="flex flex-col p-4 gap-4">
        <div className="p-2">
          <p className="my-bold text-sm">Notifications</p>
        </div>

        <div className="flex flex-col px-2 pb-2 gap-4">
          {notifications.map((n, i) => (
            <NotificationItem key={i} icon={n.icon} message={n.message} time={n.time} />
          ))}
        </div>
      </div>
      <div className="flex flex-col p-4 gap-4">
        <div className="p-2">
          <p className="my-bold text-sm">Activities</p>
        </div>

        <div className="flex flex-col px-2 pb-2 gap-4">
          {activities.map((n, i) => (
            <ActivitiesItem key={i} imageSrc={n.imageSrc} message={n.message} time={n.time} />
          ))}
        </div>
      </div>
      <div className="flex flex-col p-4 gap-4">
        <div className="p-2">
          <p className="my-bold text-sm">Contacts</p>
        </div>

        <div className="flex flex-col px-2 pb-2 gap-2">
          {contacts.map((n, i) => (
            <ContactsItem key={i} imageSrc={n.imageSrc} name={n.name} />
          ))}
        </div>
      </div>
    </div>
  );
}
